import React, { FC } from 'react'
import { HStack, Typography, VStack, XelaColor } from '@/XelaReact'
import { router } from '@inertiajs/react'
import Notification = App.Models.Notification

const PaymentReminderToLeadManagerNotification: FC<{
  notification: Notification
  portal?: string
}> = ({ notification }) => {
  return (
    <VStack
      onClick={() => {
        if (notification.data.lead_id === null) return
        if (notification.data.lead_type === 'App\\Models\\VisitorLead') {
          router.visit(
            route('visitor-leads.id', {
              id: notification.data.lead_id,
              show_tab: 'payments',
            })
          )
        } else if (notification.data.lead_type === 'App\\Models\\IeltsLead') {
          router.visit(
            route('ielts-leads.id', {
              id: notification.data.lead_id,
              show_tab: 'payments',
            })
          )
        } else {
          router.visit(
            route('leads.id', {
              id: notification.data.lead_id,
              show_tab: 'payments',
            })
          )
        }
      }}
    >
      <VStack
        spacing="3px"
        style={{
          flexWrap: 'wrap',
          cursor: 'pointer',
          padding: '6px 12px',
        }}
      >
        <Typography variant="body-small-bold">Upcoming Pending Payment : </Typography>
        <HStack spacing={'8px'}>
          <Typography variant="body-small" color={XelaColor.Gray6}>
            Lead Name:
          </Typography>
          <Typography variant="body-small-bold" color={XelaColor.Orange3}>
            #{notification.data.lead_name}
          </Typography>
          <Typography variant="body-small" color={XelaColor.Gray6}>
            Due Date:
          </Typography>
          <Typography variant="body-small">{notification.data.payment_due_date}</Typography>
        </HStack>
        <HStack spacing={'8px'}>
          <Typography variant="body-small" color={XelaColor.Gray6}>
            Amount:
          </Typography>
          <Typography variant="body-small">{notification.data.payment_amount}</Typography>
        </HStack>
      </VStack>
    </VStack>
  )
}

export default PaymentReminderToLeadManagerNotification
